import { parseISO, format, isBefore } from "date-fns";
import esLocale from "date-fns/locale/es";

export default class FormatDatesValueObject {
  private readonly _date: string;

  constructor(date: string) {
    this._date = date;
  }

  public value() {
    if (!this._date) {
      return "";
    }
    const date = parseISO(this._date);

    const formatedDate = format(date, "d MMM, yyyy h:mm aa", {
      locale: esLocale,
    });

    const formatedDateShort = format(date, "dd/MM h aa", {
      locale: esLocale,
    });

    const formatedDateShortWithYear = format(date, "dd/MM/yy", {
      locale: esLocale,
    });

    const formatedTime = format(date, "hh:mm aaaa", {
      locale: esLocale,
    });

    const formatDateAlert = format(date, "d 'de' MMMM 'a las' h:mm aa", {
      locale: esLocale,
    });

    const formatDateAlertB = format(date, "d MMM'.' yyyy", {
      locale: esLocale,
    });

    const isBeforeCurrentDate = isBefore(date, new Date());

    return {
      long: formatedDate,
      longC: `${formatedDateShortWithYear} a las ${formatedTime}`,
      time: formatedTime,
      short: formatedDateShort,
      shortB: formatedDateShortWithYear,
      alert: formatDateAlert,
      alertB: formatDateAlertB,
      normal: date,
      isBeforeCurrentDate,
    };
  }
}
